export default __webpack_public_path__ + "static/media/orangeCircle.aae7a3ae.svg";